import {getDefaultPieFormatting} from '@/containers/E4ImpactMBA/charts/pie';

const transformData = [
    {
        name: 'Achieving market and profits',
        value: 'Item 1'
    },
    {
        name: 'Addressing environmental problems',
        value: 'Item 2'
    },
    {
        name: 'Serving marginalised communities with my product/service',
        value: 'Item 3'
    },
    {
        name: 'Employing vulnerable and marginalized people in my business',
        value: 'Item 4'
    },
    {
        name: 'Other',
        value: 'other'
    }
];

/**
 * question: What are your main purposes in doing business?
 * == baseline
 * question11_(0-5)
 * 
 * @param props 
 * @returns 
 */
export const mainPurposesBusinessChartCalculation = (props: any) => {
    return getDefaultPieFormatting(
        'Main purposes of the business',
        transformData.map(({name, value}) => ({
            name,
            y: props.baselineSubmissions.filter((submission: any) => {
                for (let i = 0; i < transformData.length; i++) {
                    if (submission[`question11_${i}`] === value) {
                        return true;
                    }
                }
                
                return false;
            }).length
        }))
    ) as  Highcharts.Options;
}